export default __webpack_public_path__ + "static/media/gouni.9cf121b4.png";